import aila from "@/assets/aila.jpg";
import brett from "@/assets/brett.jpg";
import ren from "@/assets/ren.jpg";


const nameMap = {
  Aila: {
    imageSrc: aila,
    winnings: '$1,673.10',
  },
  Brett: {
    imageSrc: brett,
    winnings: '$423.40',
  },
  Ren: {
    imageSrc: ren,
    winnings: '$506.82',
  }
}

export function WinnerCard({ name, rotation }: { name: 'Aila' | 'Brett' | 'Ren'; rotation: number }) {
    const { imageSrc, winnings } = nameMap[name];
    // console.log(nameMap[name]);
  
    return (
      <div className='btn-bounce-subtle'>
        <div 
          className="bg-white p-1 shadow-lg rounded-lg h-20 flex items-center justify-center"
          style={{ zIndex: 10, transform: `rotate(${rotation}deg)` }}
        >
          <div className="flex flex-row items-center justify-center px-3">
            <img src={imageSrc} className='h-12 ml-0.5' alt='winner-img'/>
            <div className="ml-2">
              <h1 className="text-blue-dark text-xl font-semibold">{name} won {winnings}</h1>
              <p className='text-gray-400 font-semibold translate-x-[1px]'>Recent scratcher win 🔥</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

